import {
    AMBER,
    DARK_GREEN,
    SWEGON_GREEN,
    RED,
    LIGHT_GREY,
    PALE_GREEN,
    ORANGE,
    GREY3
} from '@swegon-core/uic/dist/src/theme';
import styled from 'styled-components';
import { AHUD_AMBER_25, AHUD_PURPLE } from '../../../theme';

interface CalculationResultContainerProps {
    $numberofcolumns: number;
}

interface StyledSmallGridItem {
    $shouldhighlightwarnings: string;
}

interface StyledLargeGridItem {
    $calculationstatus: string;
    $calccompletion: number;
    $calcerrormessage?: string;
}

interface StyledGridLabel {
    $calculationstatus?: string;
}

export const CalculationResultContainer = styled.div<CalculationResultContainerProps>`
    display: grid;
    grid-column: 1/-1;
    grid-template-columns: repeat(${(props) => props.$numberofcolumns}, 1fr);
    grid-gap: 0 2px;
    width: 100%;
`;

export const OuterCalculationResultContainer = styled.div<CalculationResultContainerProps>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.$numberofcolumns}, 1fr);
    grid-gap: 4px 0;
    align-items: center;
    justify-items: center;
    padding: 16px 0 8px 0;
    height: fit-content;
`;

export const Title = styled.div`
    grid-column: 1/-1;
`;

export const ResultsContainer = styled.div`
    display: contents;
`;

const GridItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 40px;
`;

export const SmallGridItem = styled(GridItem)<StyledSmallGridItem>`
    background: ${(props) =>
        props?.$shouldhighlightwarnings === 'true'
            ? `${AHUD_AMBER_25}`
            : PALE_GREEN};
    border-bottom: ${(props) =>
        props.$shouldhighlightwarnings === 'true'
            ? `3px solid ${AMBER}`
            : `solid 3px ${DARK_GREEN}`};
`;

export const LargeGridItem = styled(GridItem)<StyledLargeGridItem>`
    grid-column: 1/-1;
    padding-bottom: 3px;

    ${(props) =>
        props.$calculationstatus === 'CALC_RUNNING' &&
        `
            background: linear-gradient(
                to right, 
                ${props.$calccompletion < 50 ? DARK_GREEN : SWEGON_GREEN} ${props.$calccompletion}%,
                ${LIGHT_GREY} ${props.$calccompletion}%
            )
            left 
            bottom
            ${LIGHT_GREY}
            no-repeat;
            background-size:100% 5px;
    `};

    ${(props) =>
        (props.$calculationstatus === 'CALC_NEEDS_REFRESH' ||
            props.$calculationstatus === 'CALC_DISABLED') &&
        `
            background: linear-gradient(
                to right, 
                ${AHUD_PURPLE} ${props.$calccompletion}%,
                ${LIGHT_GREY} ${props.$calccompletion}%
            )
            left 
            bottom
            ${LIGHT_GREY}
            no-repeat;
            background-size:100% 3px;
    `};

    ${(props) =>
        props.$calculationstatus === 'CALC_RES_ERROR' &&
        `
            background: linear-gradient(
                to right, 
                ${RED} ${props.$calccompletion}%,
                ${LIGHT_GREY} ${props.$calccompletion}%
            )
            left 
            bottom
            ${LIGHT_GREY}
            no-repeat;
            background-size:100% 3px;
            white-space:wrap;
    `};

    ${(props) =>
        props.$calculationstatus === 'CALC_RES_ERROR' &&
        props?.$calcerrormessage?.length &&
        props.$calcerrormessage.length >= 50 &&
        `
            height: 125px;
    `};
`;

export const GridLabel = styled.label<StyledGridLabel>`
    font-size: 1rem;
    font-weight: 400;
    opacity: ${(props) =>
        props.$calculationstatus === 'CALC_RUNNING' ? 0.5 : 1};
    overflow: hidden;
    max-width: 80%;
`;

export const GridLabelSpan = styled.span`
    display: flex;
    align-items: center;
    vertical-align: bottom;
`;

export const Header = styled.div`
    display: contents;
    font-size: 0.875rem;
`;

export const Spans = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 90%;
    color: ${GREY3};
    font-weight: 400;
`;

export const CalcButtonContainer = styled.div`
    display: flex;
    z-index: 99;
    align-self: end;
`;

export const WarningButtonContainer = styled.div`
    cursor: pointer;
`;

export const WarningButtonText = styled.span`
    color: ${ORANGE};
    font-family: 'SwegonBrown';
    font-weight: 300;
    font-size: 16px;
    text-transform: none;
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
`;

export const DisclaimerText = styled.div`
    font-family: 'SwegonBrown';
    font-size: 12px;
    font-weight: 300;
    line-height: 20px;
    text-align: center;
    align-self: center;
    width: 90%;
`;
